var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dg-button',{staticClass:"dg-ppm__create-container__btn",on:{"click":_vm.navigateTo}},[_c('img',{staticClass:"dg-ppm__create-container__btn-icon",attrs:{"src":require(`../../images/dpa-${_vm.type}.svg`),"alt":""}}),_vm._v(" "+_vm._s(_vm.$t(`ppm.create_section.${_vm.type}.btnLabel`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }